import {Injectable} from '@angular/core';
import {SessionStorageKeysEnum} from '../models/session-storage-keys-enum';
import {NewServiceErrorEnum} from '../enums/new-service-error.enum';
import {Router} from '@angular/router';
import {AdviserClientSessionState} from '../enums/adviser-client-session-state';
import {environment} from '../../../environments/environment';
import {SandboxRequestService} from './sandbox/sandbox-request.service';
import {BdbSessionStrgService} from '@npm-bbta/bbog-cm-auth-lib';

@Injectable()
export class SingleSessionService {

    // @ts-ignore
    private intervalID: ReturnType<typeof setInterval>;
    constructor(private readonly bdbSessionStorageService: BdbSessionStrgService,
                private readonly sandboxRequestService: SandboxRequestService,
                private readonly router: Router,
                ) {
    }
    public initIntervalCallSingleSession(clientCC: string, adviserCC: string, uuid: string) {
        const isSelfManagement = this.bdbSessionStorageService.get(SessionStorageKeysEnum.SELF_MANAGEMENT) + '' === 'true';
        if (isSelfManagement) {
            adviserCC = uuid;
        }
        this.intervalID = setInterval(this.callValidateSingleSession.bind(this, clientCC, adviserCC, uuid), environment.callSingleSessionIntervalMs);
    }


    public async callValidateSingleSession(clientCC: string, adviserCC: string, uuid: string): Promise<void> {
        console.log('[INFO] callValidateSingleSession clientCC', clientCC);
        if (clientCC) {
            console.log(`[INFO] Data for callValidateSingleSession clientCC: ${clientCC} uuid: ${uuid} adviserCC:${adviserCC}`);
            const response = await this.validateSingleSession(adviserCC, clientCC, uuid);
            console.log('[INFO] Response from validateSingleSession', response);
            if (response === 'ALREADY_HAS_A_SESSION') {
                clearInterval(this.intervalID);
                this.bdbSessionStorageService.save(SessionStorageKeysEnum.ERROR_CODE, NewServiceErrorEnum.SINGLE_SESSION_BLOCKED);
                console.log('[INFO] Redirecting to error page ', this.bdbSessionStorageService.get(SessionStorageKeysEnum.ERROR_CODE));
                await this.router.navigate(['error']);
            }
        }
    }

    async validateSingleSession(adviserCC: string, clientCC: string, uuid: string): Promise<AdviserClientSessionState> {
        try {
            const url = `${environment.sandboxV3Domain}/auth/V1/product/authenticator/update-session-adviser-client`
            const body = {
                adviser_cc: adviserCC,
                client_cc: clientCC,
                uuid: uuid
            };
            const newHeaders = {}
            Object.assign(newHeaders, {'content-type': 'application/json'});
            delete newHeaders['Content-Type'];
            const response = await this.sandboxRequestService.requestPostSandbox(url, body, newHeaders);
            console.log('[INFO] Response from validateSingleSession', response.body);
            return response.body.message as AdviserClientSessionState;
        } catch (e) {
            console.error('[ERROR] Error in validateSingleSession', e);
            return AdviserClientSessionState.ERROR;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/single-session.service.ts